/* eslint-disable */
export default function (Vue) {
  Vue.helper = {
    /**
     *
     * @param key {String}
     * @param prop {String}
     * @param objectArr {Array}
     */
    getObjectsByKey(key, prop, objectArr) {
      return objectArr.filter(obj => obj[key] === prop)
    },
    getTimeStamp() {
      const now = new Date()
      const minutes = now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes()
      const seconds = now.getSeconds() < 10 ? '0' + now.getSeconds() : now.getSeconds()
      const date = now.getDate() < 10 ? '0' + now.getDate() : now.getDate()
      const month = (now.getMonth() + 1) < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth() + 1)

      return (
        (now.getFullYear()) + '-' + month + '-' + date + ' ' +
        now.getHours() + ':' + minutes + ':' + seconds
      )
    },
    capitalize(val) {
      String.prototype.capitalizeFirstLetter = function () {
        return this.charAt(0).toUpperCase() + this.slice(1);
      };
      val.capitalizeFirstLetter();
    },
    cpObj(o) {
      let tmp = {};
      Object.keys(o).forEach(key => {
        tmp[key] = o[key];
      });
      return tmp;
    },
    getLocation() {
      return 'https://admin.tec-stuttgart.de';
    },
    imgServerUrl() {
      return 'https://admin.tec-stuttgart.de';
    },
    apiUrl() {
      return 'https://admin.tec-stuttgart.de/api'
    },
    /**
     *  Finds y value of given object
     * @param obj {object}
     * @returns {[Integer]} offset from top
     */
    findPos(obj) {
      let curtop = 0;
      if (obj.offsetParent) {
        do {
          curtop += obj.offsetTop;
        } while (obj = obj.offsetParent);
        return [curtop];
      }
    },
  };
  Object.defineProperties(Vue.prototype, {
    $helper: {
      get() {
        return Vue.helper;
      },
    }
  })
}
